import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { documentReadPath } from '../lib/document-route'
import { useAppStore } from '../stores/app-store'
import { isSourceBackedDocument } from '../lib/document-kind'

export interface RoutableDocument {
  id: string
  title: string
  slug?: string | null
  sourceProvenance?: unknown | null
}

export function useOpenDocumentRoute() {
  const navigate = useNavigate()
  const { openTab, setActiveTab } = useAppStore()

  return useCallback(
    (doc: RoutableDocument) => {
      if (
        Object.prototype.hasOwnProperty.call(doc, 'sourceProvenance') &&
        !isSourceBackedDocument(doc)
      ) {
        const tabId = `tab-${doc.id}`
        openTab({ id: tabId, documentId: doc.id, title: doc.title })
        setActiveTab(tabId)
      }
      navigate(documentReadPath(doc))
    },
    [navigate, openTab, setActiveTab],
  )
}
